import React from 'react';
import '../../resources/global.css'

function Logo(props) {
    return (
        <div className="official-logo" style={{...props.style}}>
            Ou<span style={{color: 'var(--theme-orange)'}}>Media</span>
        </div>
    );
}

export default Logo;